const initialState = {
    thirdPartyRiskStats: null,
    similarDomainList: null,
    subDomainList: null,
    ipAddressList: null,
    cvesList: null,
    subdomainTakeoverList: null,
    sslVulnerabilitiesList: null,
    botnetLeaksList: null,
    leakedCredentialsList: null,
    cerStats: null,
    cerDataList: null,
    riskOverTime: null,
    riskAssessment: null,
    securityOverview: null,
    compromiseIndicator: null,
    brandInsight: null,
    overAllRiskScore: null,
    thirdPartyVendorStats: null,
    vendorRiskProfileList: null,
    vendorOverviewList: null,
    vendorScoreChange: null,
    vendorRiskBusinessImpact: null,
    gitLeaksList: null,
    ransomwereGroupData: null,
    riskScoreOverview: null,
    cyberRatingStats: null,
    digitalFootPrintStats: null,
    riskFindingStats: null,
    topTechnologiesStats: null,
    topVulnerabilitiesStats: null,
    sslExpiryStats: null,
    sslVulnerabilitiesStats: null,
    becStats: null,
    countryStats: null,
    vulnerabilitiesTrendStats: null
}

export default function thirdPartyRiskReducer(state=initialState, action) {
    switch(action.type) {
        case 'THIRD_PARTY_RISK_STATS':
            return {
                ...state,
                thirdPartyRiskStats: action.payload
            }
        case "RESET_THIRD_PARTY_RISK_STATS":
            return {
                ...state,
                thirdPartyRiskStats: null
            }
        case "SIMILAR_DOMAIN_LIST_SUCCESS":
            return {
                ...state,
                similarDomainList: action.payload
            }
        case "RESET_SIMILAR_DOMAIN_LIST":
            return {
                ...state,
                similarDomainList: null
            }
        case "SUBDOMAIN_LIST_SUCCESS":
            return {
                ...state,
                subDomainList: action.payload
            }
        case "RESET_SUBDOMAIN_LIST":
            return {
                ...state,
                subDomainList: null
            }
        case "IP_ADDRESS_LIST_SUCCESS": 
            return {
                ...state,
                ipAddressList: action.payload
            }
        case "RESET_IP_ADDRESS_LIST":
            return {
                ...state,
                ipAddressList: null
            }
        case "CVES_LIST_SUCCESS":
            return {
                ...state,
                cvesList: action.payload
            }
        case "RESET_CVES_LIST":
            return {
                ...state,
                cvesList: null
            }
        case "SUBDOMAIN_TAKEOVER_LIST_SUCCESS":
            return {
                ...state,
                subdomainTakeoverList: action.payload
            }
        case "RESET_SUBDOMAIN_TAKEOVER_LIST":
            return {
                ...state,
                subdomainTakeoverList: null
            }
        case "SSL_VULNERABILITIES_LIST_SUCCESS":
            return {
                ...state,
                sslVulnerabilitiesList: action.payload
            }
        case "RESET_SSL_VULNERABILITIES_LIST":
            return {
                ...state,
                sslVulnerabilitiesList: null
            }
        case "BOTNET_LEAKS_LIST_SUCCESS" :
            return {
                ...state,
                botnetLeaksList: action.payload
            }
        case "RESET_BOTNET_LEAKS_LIST":
            return {
                ...state,
                botnetLeaksList: null
            }
        case "LEAKED_CREDENTIALS_LIST_SUCCESS":
            return {
                ...state,
                leakedCredentialsList: action.payload
            }
        case "RESET_LEAKED_CREDENTIALS_LIST":
            return {
                ...state,
                leakedCredentialsList: null
            }
        case 'CER_STATS_SUCCESS':
            return {
                ...state,
                cerStats: action.payload
            }
        case 'RESET_CER_STATUS':
            return {
                ...state,
                cerStats: null
            }
        case 'CER_DATA_SUCCESS':
            return {
                ...state,
                cerDataList: action.payload
            }
        case 'RESET_CER_DATA_LIST':
            return {
                ...state,
                cerDataList: null
            }
        case "RISK_OVER_TIME_SUCCESS":
            return {
                ...state,
                riskOverTime: action.payload
            }
        case "RESET_RISK_OVER_TIME":
            return {
                ...state,
                riskOverTime: null
            }
        case "RISK_ASSESSMENT_SUCCESS":
            return {
                ...state,
                riskAssessment: action.payload
            }
        case "SECURITY_OVERVIEW_SUCCESS":
            return {
                ...state,
                securityOverview: action.payload
            }
        case "COMPROMISE_INDICATOR_SUCCESS":
            return {
                ...state,
                compromiseIndicator: action.payload
            }
        case "BRAND_INSIGHT_SUCCESS":
            return {
                ...state,
                brandInsight: action.payload
            }
        case "OVERALL_RISK_SCORE_SUCCESS":
            return {
                ...state,
                overAllRiskScore: action.payload
            }
        case "THIRD_PARTY_VENDOR_STATS_SUCCESS":
            return {
                ...state,
                thirdPartyVendorStats: action.payload
            }
        case "RESET_THIRD_PARTY_VENDOR_STATS":
            return {
                ...state,
                thirdPartyVendorStats: null
            }
        case "VENDOR_RISK_PROFILE_LIST_SUCCESS":
            return {
                ...state,
                vendorRiskProfileList: action.payload
            }
        case "RESET_VENDOR_RISK_PROFILE_LIST":
            return {
                ...state,
                vendorRiskProfileList: null
            }
        case "VENDOR_OVERVIEW_LIST_SUCCESS":
            return {
                ...state,
                vendorOverviewList: action.payload
            }
        case "RESET_VENDOR_OVERVIEW_LIST":
            return {
                ...state,
                vendorOverviewList: null
            }
        case "VENDOR_SCORE_CHANGE_SUCCESS":
            return {
                ...state,
                vendorScoreChange: action.payload
            }
        case "RESET_VENDOR_SCORE_CHANGE":
            return {
                ...state,
                vendorScoreChange: null
            }
        case "VENDOR_RISK_BUSINESS_IMPACT_LIST_SUCCESS":
            return {
                ...state,
                vendorRiskBusinessImpact: action.payload
            }
        case "RESET_VENDOR_RISK_BUSINESS_IMPACT_LIST":
            return {
                ...state,
                vendorRiskBusinessImpact: null
            }
        case 'GIT_LEAKS_SUCCESS':
            return {
                ...state,
                gitLeaksList: action.payload
            }
        case 'RESET_GIT_LEAKS_LIST':
            return {
                ...state,
                gitLeaksList: null
            }
        case 'RANSOMEWARE_DATA_SUCCESS':
            return {
                ...state,
                ransomwereGroupData: action.payload
            }
        case 'OVERALL_RISK_SCORE_OVERVIEW_SUCCESS':
            return {
                ...state,
                riskScoreOverview: action.payload
            }
        case 'CYBER_RATING_STATS_SUCCESS':
            return {
                ...state,
                cyberRatingStats: action.payload
            }
        case 'DIGITAL_FOOTPRINT_STATS_SUCCESS':
            return {
                ...state,
                digitalFootPrintStats: action.payload
            }
        case 'RISK_FINDINGS_STATS_SUCCESS':
            return {
                ...state,
                riskFindingStats: action.payload
            }
        case 'TOP_TECHNOLOGIES_STATS_SUCCESS':
            return {
                ...state,
                topTechnologiesStats: action.payload
            }
        case 'TOP_VULNERABILITIES_STATS_SUCCESS':
            return {
                ...state,
                topVulnerabilitiesStats: action.payload
            }
        case 'SSL_EXPIRY_STATS_SUCCESS':
            return {
                ...state,
                sslExpiryStats: action.payload
            }
        case 'SSL_VULNERABILITIES_STATS_SUCCESS':
            return {
                ...state,
                sslVulnerabilitiesStats: action.payload
            }
        case 'BEC_STATS_SUCCESS':
            return {
                ...state,
                becStats: action.payload
            }
        case 'COUNTRY_STATS_SUCCESS':
            return {
                ...state,
                countryStats: action.payload
            }
        case 'VULNERABILITIES_TREND_STATS_SUCCESS':
            return {
                ...state,
                vulnerabilitiesTrendStats: action.payload
            }
        default:
            return state;
    }
}